import styled from 'styled-components';

export const CategoryContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 50px;
    
    @media screen and (max-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px; 
    }

   @media screen and (max-width: 750px) {
        grid-template-columns: repeat(2, 1fr);
        column-gap: 20px;
    }

     @media screen and (max-width: 500px) {
        grid-template-columns: repeat(1, 1fr);
    }

`

export const CategoryTitle = styled.h2`
    font-size: 38px;
    margin-bottom: 25px;
    text-align: center;

`
